import { FLOW_MODES } from '@avanta/shared/constants/appointments';

export const AppointmentsReservePayload = {
  //Form fields
  psychologist: 'psychologist',
  dateTime: 'dateTime',
  backofficeCenterId: 'backofficeCenterId',
  specialityBooked: 'specialityBooked',
  psychologistServiceBooked: 'psychologistServiceBooked',
  observations: 'observations',
  contractId: 'contractId',
  contractRateId: 'contractRateId',
  contractAuthorization: 'contractAuthorization',
  recordFields: 'recordFields',
  //States
  durationType: 'durationType',
  city: 'city',
  flow: 'flow',
  currentStepName: 'currentStepName',
  document: 'document',
  hasExpedient: 'hasExpedient',
  patient: 'patient',
} as const;

export const AppointmentSteps = {
  patient: 'patient',
  data: 'data',
  session: 'session',
  confirmation: 'confirmation',
  facultative: 'facultative',
} as const;

export const FLOW_STEP_NAMES = {
  [FLOW_MODES.regular]: [
    AppointmentSteps.data,
    AppointmentSteps.session,
    AppointmentSteps.confirmation,
  ],
  [FLOW_MODES.search_patient]: [
    AppointmentSteps.patient,
    AppointmentSteps.data,
    AppointmentSteps.session,
    AppointmentSteps.confirmation,
  ],
  [FLOW_MODES.search_facultative]: [
    AppointmentSteps.data,
    AppointmentSteps.facultative,
    AppointmentSteps.session,
    AppointmentSteps.confirmation,
  ],
  [FLOW_MODES.edit]: [AppointmentSteps.session, AppointmentSteps.confirmation],
} as const;
